import React from 'react';
import { IIconProps } from './utils';

export const CheckmarkCircle = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 14 14" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.45982 7.28191L6.15337 8.97546L9.54046 5.58836M7.00014 12.6448C3.88241 12.6448 1.35498 10.1174 1.35498 6.99965C1.35498 3.88192 3.88241 1.35449 7.00014 1.35449C10.1179 1.35449 12.6453 3.88192 12.6453 6.99965C12.6453 10.1174 10.1179 12.6448 7.00014 12.6448Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.12903"
    />
  </svg>
);
